export default "__VITE_ASSET__Cg6AR6u3__"